/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { TwoArguments } from "./TwoArguments";

export class TwoArgumentsFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<TwoArguments> {
    return super.deploy(overrides || {}) as Promise<TwoArguments>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): TwoArguments {
    return super.attach(address) as TwoArguments;
  }
  connect(signer: Signer): TwoArgumentsFactory {
    return super.connect(signer) as TwoArgumentsFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TwoArguments {
    return new Contract(address, _abi, signerOrProvider) as TwoArguments;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "argumentOne",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "bytes4",
        name: "argumentTwo",
        type: "bytes4",
      },
    ],
    name: "TwoArgumentsCalled",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "argumentOne",
        type: "address[]",
      },
      {
        internalType: "bytes4",
        name: "argumentTwo",
        type: "bytes4",
      },
    ],
    name: "twoArguments",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b506101b9806100206000396000f3fe608060405234801561001057600080fd5b506004361061002b5760003560e01c806372e0745c14610030575b600080fd5b6100d06004803603604081101561004657600080fd5b810190808035906020019064010000000081111561006357600080fd5b82018360208201111561007557600080fd5b8035906020019184602083028401116401000000008311171561009757600080fd5b909192939192939080357bffffffffffffffffffffffffffffffffffffffffffffffffffffffff191690602001909291905050506100d2565b005b7fc983106aca50fad459fb18ede1630e8ff8147ff28ad451a856427931fd7f15e38383836040518080602001837bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19167bffffffffffffffffffffffffffffffffffffffffffffffffffffffff191681526020018281038252858582818152602001925060200280828437600081840152601f19601f82011690508083019250505094505050505060405180910390a150505056fea2646970667358221220935ca28aeb2c7c4f5a03e632b39ce58e64f9ae550e02a4a5306e2d6dbc7a941d64736f6c63430006040033";
